import styled, {
    color as colorStyles,
    ColorProps,
    css,
    device,
    themeGet,
} from "@doar/shared/styled";
import {
    ModalBody,
    ModalHeader,
    ModalFooter,
    ModalClose,
    Card,
    Button,
} from "@doar/components";
import Modal from "src/components/custom-modal";

export const StyledImg = styled.img`
    &.listImage {
        min-height: 75px;
        min-width: 75px;
        max-width: 75px;
        max-height: 75px;
    }
    &.showImage {
        max-height: 40vh;
        @media (min-width: 1300px) {
            max-height: 60vh;
        }
    }
    object-fit: contain;
`;

export const StyledModal = styled(({ ...rest }) => <Modal {...rest} />)`
    z-index: 10000;
    & .modal-dialog {
        ${device.large} {
            padding-bottom: 20px;
        }
        padding-bottom: 0;
        height: 95%;
        max-width: 87.5%;
        & .modal-content {
            height: 98%;
        }
    }
`;

export const StyledModalClosed = styled(({ ...rest }) => (
    <ModalClose {...rest} />
))``;

export const StyledWrapFooter = styled.div`
    ${device.medium} {
        width: 46.5vw;
    }
    ${device.large} {
        width: 900px;
    }
    width: 65vw;
`;

export const StyledBoxWrap = styled.div`
    &.is-selected {
        box-shadow: 0 0 6px 1px #0168fa;
    }
    min-width: 80px;
    max-width: 80px;
    border: 1px solid #485e9029;
    border-radius: 4px;
    cursor: pointer;
    margin: 5px;
`;

export const StyledWrap = styled.div`
    &.imageFile {
        height: 100%;
        width: 100%;
    }
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyleButtonWrap = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledWrapIcon = styled.div`
    display: flex;
    ${device.large} {
        padding-top: 0;
    }
    padding-top: 20px;
`;

export const StyledButton = styled(({ ...rest }) => <Button {...rest} />)`
    height: 70px;
    width: 70px;
    border-radius: 50%;
    background-color: #f9f9f9;
    border: none;
    color: #031939;
    &:hover,
    &:focus {
        color: #fff;
    }
`;

export const StyledModalBody = styled(({ ...rest }) => <ModalBody {...rest} />)`
    padding: 15px;
    display: grid;
    grid-template-columns: 15% 70% 15%;
    align-items: center;
    height: 100%;
    width: 100%;
`;

export const StyledModalHeader = styled(({ ...rest }) => (
    <ModalHeader {...rest} />
))`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 30px;
    & .modalView {
        display: flex;
        ${device.large} {
            width: 100%;
            display: block;
        }
        flex-wrap: wrap;
        width: 150px;
    }
`;

export const StyledModalFooter = styled(({ ...rest }) => (
    <ModalFooter {...rest} />
))`
    justify-content: center;
`;

export const StyledCard = styled(({ ...rest }) => <Card {...rest} />)`
    padding: 10px;
    width: 80px;
    height: 80px;
    position: relative;
    border-color: ${themeGet("colors.border")};
    transition: all 0.2s ease-in-out;
    &:hover,
    &:focus {
        border-color: ${themeGet("colors.text4")};
    }
    span {
        font-size: 12px;
        color: ${themeGet("colors.text3")};
    }
    p {
        margin-bottom: 0;
        color: ${themeGet("colors.river")};
    }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledThumb = styled(({ color, ...rest }) => (
    <div {...rest} />
))<ColorProps>`
    background-color: ${themeGet("colors.whisper")};
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    ${device.small} {
        height: 100px;
        font-size: 40px;
    }
    ${device.large} {
        height: 120px;
        font-size: 48px;
    }
    ${(props) =>
        props.theme.name === "dark" &&
        css`
            background-color: ${themeGet("colors.darkdarken2")};
        `}
    ${colorStyles};
`;
